module.exports = __webpack_public_path__ + "static/media/offroad.cec12980.svg";